webpackJsonp([79611799117203,60335399758886],{

/***/ 274:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(385);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(274);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * EvEmitter v1.1.0
	 * Lil' event emitter
	 * MIT License
	 */
	
	/* jshint unused: true, undef: true, strict: true */
	
	( function( global, factory ) {
	  // universal module definition
	  /* jshint strict: false */ /* globals define, module, window */
	  if ( true ) {
	    // AMD - RequireJS
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS - Browserify, Webpack
	    module.exports = factory();
	  } else {
	    // Browser globals
	    global.EvEmitter = factory();
	  }
	
	}( typeof window != 'undefined' ? window : this, function() {
	
	"use strict";
	
	function EvEmitter() {}
	
	var proto = EvEmitter.prototype;
	
	proto.on = function( eventName, listener ) {
	  if ( !eventName || !listener ) {
	    return;
	  }
	  // set events hash
	  var events = this._events = this._events || {};
	  // set listeners array
	  var listeners = events[ eventName ] = events[ eventName ] || [];
	  // only add once
	  if ( listeners.indexOf( listener ) == -1 ) {
	    listeners.push( listener );
	  }
	
	  return this;
	};
	
	proto.once = function( eventName, listener ) {
	  if ( !eventName || !listener ) {
	    return;
	  }
	  // add event
	  this.on( eventName, listener );
	  // set once flag
	  // set onceEvents hash
	  var onceEvents = this._onceEvents = this._onceEvents || {};
	  // set onceListeners object
	  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
	  // set flag
	  onceListeners[ listener ] = true;
	
	  return this;
	};
	
	proto.off = function( eventName, listener ) {
	  var listeners = this._events && this._events[ eventName ];
	  if ( !listeners || !listeners.length ) {
	    return;
	  }
	  var index = listeners.indexOf( listener );
	  if ( index != -1 ) {
	    listeners.splice( index, 1 );
	  }
	
	  return this;
	};
	
	proto.emitEvent = function( eventName, args ) {
	  var listeners = this._events && this._events[ eventName ];
	  if ( !listeners || !listeners.length ) {
	    return;
	  }
	  // copy over to avoid interference if .off() in listener
	  listeners = listeners.slice(0);
	  args = args || [];
	  // once stuff
	  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];
	
	  for ( var i=0; i < listeners.length; i++ ) {
	    var listener = listeners[i]
	    var isOnce = onceListeners && onceListeners[ listener ];
	    if ( isOnce ) {
	      // remove listener
	      // remove before trigger to prevent recursion
	      this.off( eventName, listener );
	      // unset once flag
	      delete onceListeners[ listener ];
	    }
	    // trigger listener
	    listener.apply( this, args );
	  }
	
	  return this;
	};
	
	proto.allOff = function() {
	  delete this._events;
	  delete this._onceEvents;
	};
	
	return EvEmitter;
	
	}));


/***/ }),

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * imagesLoaded v4.1.4
	 * JavaScript is all like "You images are done yet or what?"
	 * MIT License
	 */
	
	( function( window, factory ) { 'use strict';
	  // universal module definition
	
	  /*global define: false, module: false, require: false */
	
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(483)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( EvEmitter ) {
	      return factory( window, EvEmitter );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	      window,
	      require('ev-emitter')
	    );
	  } else {
	    // browser global
	    window.imagesLoaded = factory(
	      window,
	      window.EvEmitter
	    );
	  }
	
	})( typeof window !== 'undefined' ? window : this,
	
	// --------------------------  factory -------------------------- //
	
	function factory( window, EvEmitter ) {
	
	'use strict';
	
	var $ = window.jQuery;
	var console = window.console;
	
	// -------------------------- helpers -------------------------- //
	
	// extend objects
	function extend( a, b ) {
	  for ( var prop in b ) {
	    a[ prop ] = b[ prop ];
	  }
	  return a;
	}
	
	var arraySlice = Array.prototype.slice;
	
	// turn element or nodeList into an array
	function makeArray( obj ) {
	  if ( Array.isArray( obj ) ) {
	    // use object if already an array
	    return obj;
	  }
	
	  var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
	  if ( isArrayLike ) {
	    // convert nodeList to array
	    return arraySlice.call( obj );
	  }
	
	  // array of single index
	  return [ obj ];
	}
	
	// -------------------------- imagesLoaded -------------------------- //
	
	/**
	 * @param {Array, Element, NodeList, String} elem
	 * @param {Object or Function} options - if function, use as callback
	 * @param {Function} onAlways - callback function
	 */
	function ImagesLoaded( elem, options, onAlways ) {
	  // coerce ImagesLoaded() without new, to be new ImagesLoaded()
	  if ( !( this instanceof ImagesLoaded ) ) {
	    return new ImagesLoaded( elem, options, onAlways );
	  }
	  // use elem as selector string
	  var queryElem = elem;
	  if ( typeof elem == 'string' ) {
	    queryElem = document.querySelectorAll( elem );
	  }
	  // bail if bad element
	  if ( !queryElem ) {
	    console.error( 'Bad element for imagesLoaded ' + ( queryElem || elem ) );
	    return;
	  }
	
	  this.elements = makeArray( queryElem );
	  this.options = extend( {}, this.options );
	  // shift arguments if no options set
	  if ( typeof options == 'function' ) {
	    onAlways = options;
	  } else {
	    extend( this.options, options );
	  }
	
	  if ( onAlways ) {
	    this.on( 'always', onAlways );
	  }
	
	  this.getImages();
	
	  if ( $ ) {
	    // add jQuery Deferred object
	    this.jqDeferred = new $.Deferred();
	  }
	
	  // HACK check async to allow time to bind listeners
	  setTimeout( this.check.bind( this ) );
	}
	
	ImagesLoaded.prototype = Object.create( EvEmitter.prototype );
	
	ImagesLoaded.prototype.options = {};
	
	ImagesLoaded.prototype.getImages = function() {
	  this.images = [];
	
	  // filter & find items if we have an item selector
	  this.elements.forEach( this.addElementImages, this );
	};
	
	/**
	 * @param {Node} element
	 */
	ImagesLoaded.prototype.addElementImages = function( elem ) {
	  // filter siblings
	  if ( elem.nodeName == 'IMG' ) {
	    this.addImage( elem );
	  }
	  // get background image on element
	  if ( this.options.background === true ) {
	    this.addElementBackgroundImages( elem );
	  }
	
	  // find children
	  // no non-element nodes, #143
	  var nodeType = elem.nodeType;
	  if ( !nodeType || !elementNodeTypes[ nodeType ] ) {
	    return;
	  }
	  var childImgs = elem.querySelectorAll('img');
	  // concat childElems to filterFound array
	  for ( var i=0; i < childImgs.length; i++ ) {
	    var img = childImgs[i];
	    this.addImage( img );
	  }
	
	  // get child background images
	  if ( typeof this.options.background == 'string' ) {
	    var children = elem.querySelectorAll( this.options.background );
	    for ( i=0; i < children.length; i++ ) {
	      var child = children[i];
	      this.addElementBackgroundImages( child );
	    }
	  }
	};
	
	var elementNodeTypes = {
	  1: true,
	  9: true,
	  11: true
	};
	
	ImagesLoaded.prototype.addElementBackgroundImages = function( elem ) {
	  var style = getComputedStyle( elem );
	  if ( !style ) {
	    // Firefox returns null if in a hidden iframe https://bugzil.la/548397
	    return;
	  }
	  // get url inside url("...")
	  var reURL = /url\((['"])?(.*?)\1\)/gi;
	  var matches = reURL.exec( style.backgroundImage );
	  while ( matches !== null ) {
	    var url = matches && matches[2];
	    if ( url ) {
	      this.addBackground( url, elem );
	    }
	    matches = reURL.exec( style.backgroundImage );
	  }
	};
	
	/**
	 * @param {Image} img
	 */
	ImagesLoaded.prototype.addImage = function( img ) {
	  var loadingImage = new LoadingImage( img );
	  this.images.push( loadingImage );
	};
	
	ImagesLoaded.prototype.addBackground = function( url, elem ) {
	  var background = new Background( url, elem );
	  this.images.push( background );
	};
	
	ImagesLoaded.prototype.check = function() {
	  var _this = this;
	  this.progressedCount = 0;
	  this.hasAnyBroken = false;
	  // complete if no images
	  if ( !this.images.length ) {
	    this.complete();
	    return;
	  }
	
	  function onProgress( image, elem, message ) {
	    // HACK - Chrome triggers event before object properties have changed. #83
	    setTimeout( function() {
	      _this.progress( image, elem, message );
	    });
	  }
	
	  this.images.forEach( function( loadingImage ) {
	    loadingImage.once( 'progress', onProgress );
	    loadingImage.check();
	  });
	};
	
	ImagesLoaded.prototype.progress = function( image, elem, message ) {
	  this.progressedCount++;
	  this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
	  // progress event
	  this.emitEvent( 'progress', [ this, image, elem ] );
	  if ( this.jqDeferred && this.jqDeferred.notify ) {
	    this.jqDeferred.notify( this, image );
	  }
	  // check if completed
	  if ( this.progressedCount == this.images.length ) {
	    this.complete();
	  }
	
	  if ( this.options.debug && console ) {
	    console.log( 'progress: ' + message, image, elem );
	  }
	};
	
	ImagesLoaded.prototype.complete = function() {
	  var eventName = this.hasAnyBroken ? 'fail' : 'done';
	  this.isComplete = true;
	  this.emitEvent( eventName, [ this ] );
	  this.emitEvent( 'always', [ this ] );
	  if ( this.jqDeferred ) {
	    var jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
	    this.jqDeferred[ jqMethod ]( this );
	  }
	};
	
	// --------------------------  -------------------------- //
	
	function LoadingImage( img ) {
	  this.img = img;
	}
	
	LoadingImage.prototype = Object.create( EvEmitter.prototype );
	
	LoadingImage.prototype.check = function() {
	  // If complete is true and browser supports natural sizes,
	  // try to check for image status manually.
	  var isComplete = this.getIsImageComplete();
	  if ( isComplete ) {
	    // report based on naturalWidth
	    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
	    return;
	  }
	
	  // If none of the checks above matched, simulate loading on detached element.
	  this.proxyImage = new Image();
	  this.proxyImage.addEventListener( 'load', this );
	  this.proxyImage.addEventListener( 'error', this );
	  // bind to image as well for Firefox. #191
	  this.img.addEventListener( 'load', this );
	  this.img.addEventListener( 'error', this );
	  this.proxyImage.src = this.img.src;
	};
	
	LoadingImage.prototype.getIsImageComplete = function() {
	  // check for non-zero, non-undefined naturalWidth
	  // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671
	  return this.img.complete && this.img.naturalWidth;
	};
	
	LoadingImage.prototype.confirm = function( isLoaded, message ) {
	  this.isLoaded = isLoaded;
	  this.emitEvent( 'progress', [ this, this.img, message ] );
	};
	
	// ----- events ----- //
	
	// trigger specified handler for event type
	LoadingImage.prototype.handleEvent = function( event ) {
	  var method = 'on' + event.type;
	  if ( this[ method ] ) {
	    this[ method ]( event );
	  }
	};
	
	LoadingImage.prototype.onload = function() {
	  this.confirm( true, 'onload' );
	  this.unbindEvents();
	};
	
	LoadingImage.prototype.onerror = function() {
	  this.confirm( false, 'onerror' );
	  this.unbindEvents();
	};
	
	LoadingImage.prototype.unbindEvents = function() {
	  this.proxyImage.removeEventListener( 'load', this );
	  this.proxyImage.removeEventListener( 'error', this );
	  this.img.removeEventListener( 'load', this );
	  this.img.removeEventListener( 'error', this );
	};
	
	// -------------------------- Background -------------------------- //
	
	function Background( url, element ) {
	  this.url = url;
	  this.element = element;
	  this.img = new Image();
	}
	
	// inherit LoadingImage prototype
	Background.prototype = Object.create( LoadingImage.prototype );
	
	Background.prototype.check = function() {
	  this.img.addEventListener( 'load', this );
	  this.img.addEventListener( 'error', this );
	  this.img.src = this.url;
	  // check if image is already complete
	  var isComplete = this.getIsImageComplete();
	  if ( isComplete ) {
	    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
	    this.unbindEvents();
	  }
	};
	
	Background.prototype.unbindEvents = function() {
	  this.img.removeEventListener( 'load', this );
	  this.img.removeEventListener( 'error', this );
	};
	
	Background.prototype.confirm = function( isLoaded, message ) {
	  this.isLoaded = isLoaded;
	  this.emitEvent( 'progress', [ this, this.element, message ] );
	};
	
	// -------------------------- jQuery -------------------------- //
	
	ImagesLoaded.makeJQueryPlugin = function( jQuery ) {
	  jQuery = jQuery || window.jQuery;
	  if ( !jQuery ) {
	    return;
	  }
	  // set local variable
	  $ = jQuery;
	  // $().imagesLoaded()
	  $.fn.imagesLoaded = function( options, callback ) {
	    var instance = new ImagesLoaded( this, options, callback );
	    return instance.jqDeferred.promise( $(this) );
	  };
	};
	// try making plugin
	ImagesLoaded.makeJQueryPlugin();
	
	// --------------------------  -------------------------- //
	
	return ImagesLoaded;
	
	});


/***/ }),

/***/ 621:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 380:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _imagesloaded = __webpack_require__(553);
	
	var _imagesloaded2 = _interopRequireDefault(_imagesloaded);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoadingScreen = function (_React$Component) {
	  _inherits(LoadingScreen, _React$Component);
	
	  function LoadingScreen() {
	    _classCallCheck(this, LoadingScreen);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  LoadingScreen.prototype.componentDidMount = function componentDidMount() {
	    var siteContiner = document.querySelector('#___gatsby');
	    var pageLoading = document.body.className.match('loading');
	
	    // Stop Scrolling
	    function noScroll() {
	      window.scrollTo(0, 0);
	    }
	
	    if (pageLoading) {
	      window.addEventListener('scroll', noScroll);
	    }
	
	    (0, _imagesloaded2.default)(siteContiner, function () {
	      // disable scrolling
	      document.body.classList.remove('loading');
	      document.body.classList.add('loaded');
	      window.removeEventListener('scroll', noScroll);
	    });
	  };
	
	  LoadingScreen.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'ip-header' },
	      _react2.default.createElement(
	        'h1',
	        { className: 'ip-logo' },
	        _react2.default.createElement(
	          'svg',
	          { className: 'ip-inner', viewBox: '0 0 995 624', width: '100%', height: '100%', preserveAspectRatio: 'xMinYMin meet', 'aria-labelledby': 'logo_title' },
	          _react2.default.createElement(
	            'title',
	            { id: 'logo_title' },
	            'Goose - Trusted BigCommerce Experts'
	          ),
	          _react2.default.createElement('path', { className: 'path', stroke: '#ffffff', fill: '#ffffff', d: 'M810.5200492355824,18.777626159667967 c33.164,-7.844 66.824,-26.79 101.546,-15.023 c39.141,8.337 80.019,38.116 81.268,81.311 c0.3130000000000001,113.361 -0.135,226.77 0.266,340.13 c-14.575,-11.723 -27.099,-26.925 -45.379,-33.077 c-28.706,-10.476 -60.624,-17.696 -90.806,-9.451 c-238.802,72.575 -476.851,147.33 -715.701,219.813 c-32.855,10.526 -69.453,3.792 -98.786,-13.548 c-23.09,-14.532 -42.484,-38.832 -42.658,-67.181 c-0.405,-112.828 0.131,-225.655 -0.27,-338.482 c5.7940000000000005,-1.737 8.472,4.904 12.481,7.801 c22.602,23.807 56.123,33.926 88.042,36.555 c31.296,2.7190000000000003 61.03,-8.872 90.493,-17.43 c30.138,-10.831 61.787,-16.76 91.612,-28.486 C458.3530492355824,126.65762615966796 634.7460492355824,73.69862615966797 810.5200492355824,18.777626159667967 zM738.4810492355823,146.67162615966797 c1.2930000000000001,49.214 -0.09100000000000005,98.564 0.6220000000000002,147.776 c3.078,18.946 -12.881,34.058 -9.046,53.228 c25.854,-7.089 51.265,-15.737 77.076,-23.225 c5.524,-2.407 12.881,-3.032 16.36,-8.65 c2.359,-14.042 0.8880000000000002,-28.394 0.936,-42.528 c-13.065,2.363 -23.63,10.298 -26.347,23.671 c-8.959,3.478 -18.28,5.975 -27.774,7.357 c0.27,-23.985 0.27,-47.967 -0.04300000000000002,-71.95 c12.616,-5.172 25.632,-9.184 38.514,-13.552 c-0.4880000000000001,-9.762 2.277,-20.417 -1.737,-29.6 c-12.573,2.318 -24.34,7.847 -37.091,9.051 c0.7580000000000002,-21.31 0.6710000000000004,-42.573 0.22700000000000006,-63.881 c8.689,-4.948 18.319,-7.801 28.171,-9.406 c6.151,9.895 16.629,8.023 25.989,4.412 c0.4480000000000001,-13.82 0.401,-27.683 -0.4,-41.503 c-32.141,4.236 -62.052,18.41 -93.527,26.033 C728.4940492355823,125.76462615966796 731.8380492355824,136.86662615966796 738.4810492355823,146.67162615966797 zM592.1740492355824,196.55462615966798 c-0.266,19.971 -5.172,43.91 9.764,60.048 c12.794,14.845 36.912,11.545 48.636,27.594 c5.659,12.973 2.05,28.04 2.938,41.903 c1.92,13.954 -12.433,26.346 -25.898,24.607 c-15.559,-5.883 0.5790000000000002,-30.713 -15.067,-37.756 c-7.579,0.8900000000000002 -14.889,2.9859999999999998 -22.246,4.725 c-1.114,14.353 -1.959,28.887 0.401,43.196 c2.098,11.009 11.145,21.085 22.559,22.6 c37.178,4.057 74.756,-28.843 72.083,-67 c-1.385,-19.438 4.814,-42.216 -8.472,-58.711 c-12.39,-16.314 -35.349,-17.161 -50.194,-30.045 c-5.929,-10.43 -2.851,-23.625 -2.9859999999999998,-35.127 c-0.17900000000000005,-11.502 15.916,-24.074 25.497,-14.355 c3.7,10.298 -0.6660000000000003,24.072 9.408,31.473 c7.936,1.739 15.689,-2.407 23.447,-3.79 c0.979,-16.36 2.364,-33.299 -2.407,-49.169 c-5.215,-14.98 -23.626,-20.596 -37.713,-15.916 C615.4470492355823,146.09262615966796 593.5110492355824,169.18562615966798 592.1740492355824,196.55462615966798 zM451.3530492355824,245.67962615966798 c-0.135,48.858 -0.22200000000000006,97.717 0,146.575 c-1.023,14.932 8.202,31.696 23.983,33.878 c34.548,3.657 69.318,-24.962 70.837,-60.045 c0.6230000000000002,-49.171 0.08700000000000004,-98.34 0.266,-147.465 c0.5790000000000002,-12.838000000000001 -4.101,-27.147 -16.003,-33.523 c-11.058,-5.439 -24.253,-3.433 -35.397,0.4460000000000001 C470.2980492355823,194.50362615966796 450.41704923558234,218.62162615966798 451.3530492355824,245.67962615966798 zM484.3420492355824,392.787626159668 c14.754,5.039 31.07,-6.373 30.356,-22.2 c1.071,-43.196 -0.08700000000000004,-86.392 0.4920000000000001,-129.588 c0.4440000000000001,-9.451 -0.8920000000000002,-18.857 -4.458,-27.593 c-15.646,-0.936 -30.717,10.877 -28.262,27.637 C483.31504923558236,291.59662615966795 480.0150492355823,342.414626159668 484.3420492355824,392.787626159668 zM304.24504923558237,290.12462615966797 c-0.135,48.901 -0.22200000000000006,97.85 0,146.799 c-1.023,14.932 8.293,31.779 24.161,33.786 c34.461,3.609 69.009,-24.918 70.659,-59.867 c0.6230000000000002,-49.303 0.08700000000000004,-98.607 0.266,-147.865 c0.7570000000000002,-13.687 -5.259,-29.065 -18.632,-34.548 c-10.744,-3.657 -22.602,-2.007 -33.033,1.783 C323.10404923558235,239.26062615966796 303.4010492355824,263.19962615966796 304.24504923558237,290.12462615966797 zM337.14304923558234,437.18462615966797 c14.801,5.398 31.205,-6.191 30.447,-22.063 c1.071,-43.152 -0.04400000000000002,-86.392 0.4920000000000001,-129.544 c0.401,-9.405 -0.984,-18.767 -4.327,-27.55 c-15.689,-1.114 -30.756,10.701 -28.392,27.417 C336.07204923558237,335.996626159668 333.0860492355824,386.77162615966796 337.14304923558234,437.18462615966797 zM153.92904923558234,481.763626159668 c-0.4,16.007 10.831,31.831 26.969,34.774 c19.211,3.744 36.69,-8.158 50.107,-20.548000000000002 c4.994,3.117 10.431000000000001,6.373 16.268,2.673 c2.856,-9.764 1.385,-20.06 1.6500000000000004,-30.09 c-0.6660000000000003,-30.09 1.071,-60.272 -0.98,-90.316 c-14.131,0.7570000000000002 -27.282,6.108 -40.612,10.162 c-0.801,11.548 -1.201,23.896 9.316,31.292 c1.52,15.916 1.428,32.145 -0.5790000000000002,48.061 c-2.407,12.616 -23.626,25.85 -29.82,8.916 c-2.142,-47.303 -0.27,-94.776 -0.936,-142.162 c-1.428,-13.195 7.266,-29.69 22.246,-28.843 c13.147,5.128 5.973,21.978 11.318,31.918 c8.071,10.076 20.866,0.3120000000000001 30.36,-2.229 c-0.3570000000000001,-12.302 0.3130000000000001,-24.74 -1.6940000000000004,-36.909 c-2.856,-14.445 -16.316,-25.321 -30.983,-25.365 c-33.791,1.069 -62.81,32.23 -62.675,65.796 C153.70704923558236,386.503626159668 153.61504923558238,434.15462615966794 153.92904923558234,481.763626159668 z' })
	        )
	      )
	    );
	  };
	
	  return LoadingScreen;
	}(_react2.default.Component);
	
	exports.default = LoadingScreen;
	module.exports = exports['default'];

/***/ }),

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(50);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _LoadingScreen = __webpack_require__(380);
	
	var _LoadingScreen2 = _interopRequireDefault(_LoadingScreen);
	
	__webpack_require__(621);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Layout = function (_React$Component) {
	  _inherits(Layout, _React$Component);
	
	  function Layout() {
	    _classCallCheck(this, Layout);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Layout.prototype.render = function render() {
	    var children = this.props.children;
	
	
	    return _react2.default.createElement(
	      'div',
	      { id: 'ip-container', className: 'layout ip-container' },
	      _react2.default.createElement(_reactHelmet2.default, { defaultTitle: 'Goose: Trusted BigCommerce Experts in New Zealand' }),
	      _react2.default.createElement(_LoadingScreen2.default, null),
	      children()
	    );
	  };
	
	  return Layout;
	}(_react2.default.Component);
	
	exports.default = Layout;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-jsx-351db2d4d522bd11b3d4.js